import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loginWithToken } = useAuth(); // We might need to add this method to AuthContext

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(location.search);
            const token = params.get('token');
            const error = params.get('error');

            if (error) {
                console.error('OAuth Error:', error);
                navigate('/login?error=' + encodeURIComponent(error));
                return;
            }

            if (token) {
                try {
                    // Use AuthContext to handle the login state update
                    const result = await loginWithToken(token);

                    if (result.success) {
                        navigate('/dashboard');
                    } else {
                        console.error('Token verification failed:', result.error);
                        navigate('/login?error=' + encodeURIComponent(result.error));
                    }
                } catch (err) {
                    console.error('Failed to process token:', err);
                    navigate('/login?error=Authentication failed');
                }
            } else {
                navigate('/login');
            }
        };

        handleCallback();
    }, [location, navigate]);

    return (
        <div className="flex items-center justify-center h-screen bg-navy">
            <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-cyan/30 border-t-cyan rounded-full animate-spin"></div>
                <p className="text-white text-lg">Completing secure sign in...</p>
            </div>
        </div>
    );
};

export default AuthCallback;
